<template>
  <div v-if="companyData != null">
    <div>
      <!-- <div class="registration-head text-center" :style="styleHeader"> -->
        <div class="sml-container">
          <div class="rg-head">
            <div class="fast-retail-box" :style="styleBorder" style="width: 100%;margin-bottom: 0px;">
              <div class="fast-retail-header mb-1">
                  <!-- <div
                  :class="
                    companyData.logo_alignment
                      ? 'fast-retail-logo logo-vertical'
                      : 'fast-retail-logo logo-horizontal'
                  "
                >
                  <img
                    v-if="companyData.companyLogo !== null"
                    :src="companyData.companyLogo"
                    alt="logo"
                    class="img-fluid"
                  />
                  <i class="fas fa-building" v-else></i>
                </div> -->
                <h3>{{ companyData.companyName }}</h3>
              </div>
              <div class="info">
                <p style="margin:0px;">キャリア登録内容の確認</p>
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
      <div class="sml-container">
        <div class="rgst-sec">
          <!-- <div class="career-rgst">
            <h2>キャリア登録先企業</h2>
            <div class="fast-retail-box">
              <div
                :class="
                  companyData.logo_alignment
                    ? 'fast-retail-logo logo-vertical'
                    : 'fast-retail-logo logo-horizontal'
                "
              >
                <img
                  v-if="companyData.companyLogo !== null"
                  :src="companyData.companyLogo"
                  alt="logo"
                  class="img-fluid"
                />
                <i class="fas fa-building" v-else></i>
              </div>
              <h3>{{ companyData.companyName }}</h3>
            </div>
          </div> -->
          <!-- ends career-rgst -->
          <!-- <div class="tg-company" v-html="companyData.companyDescription"></div> -->
          <div class="rgst-dtl-sec">
              <BProfilePreview :registrationEndpoint="'Register'" @redirectToRegistrationPage="redirectToRegistrationPage"/>
          </div>
          <!-- ends rgst-dtl-sec -->
        </div>
        <!-- ends rgst-sec -->
      </div>
    </div>
    <!-- ends main-area -->
  </div>
</template>
<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import BProfilePreview from "./BProfilePreview.vue";

export default {
  name: "profilePreview",
  components: { BProfilePreview },
  data() {
    return {
      // imageData: '',
      registered: false,
      checked: false,
      fileData: "",
      submitting: false,
    };
  },
  computed: {
    ...mapGetters({
      data: "getData",
      companyData: "getCompanyData",
    }),
    styleBorder() {
      return this.companyData.brand_primary_color
        ? { border: `16px solid ${this.companyData.brand_primary_color}` }
        : { border: "#000000" };
    },
    styleButton() {
      return this.companyData.brand_secondary_color
        ? {
            background: this.companyData.brand_secondary_color,
            "border-color": this.companyData.brand_secondary_color,
          }
        : {
            background: "#000000",
            "border-color": "#000000",
          };
    },
  },
  methods: {
    ...mapActions({
      setData: "setData",
      checkCompany: "checkCompany",
      setRegEmail: "setRegEmail",
      setRegCompany: "setRegCompany",
    }),
    redirectToRegistrationPage() {
      this.$router.push({
        name: "registration",
        params: { slug: this.$route.params.slug }
      });
    },
    cancel() {
      this.$router.push({
        name: "registration",
        params: { slug: this.$route.params.slug },
      });
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
        // console.log(parent.offsetTop - (parent.offsetHeight * 2));
        // console.log(parent.offsetTop);
        // console.log(document.getElementsByClassName('form-detail')[0]);
        // document.getElementsByClassName('form-detail')[0].scrollTop =
        // parent.offsetTop - (parent.offsetHeight * 2);
      }
    },
  },
  async mounted() {
    this.scrollToTop();
    await this.setData();
    // this.photoPreview();
    const check = await this.checkCompany(this.$route.params.slug);
    if (!check) this.$router.push({ name: "Maintenance" });
  },
};
</script>
<style scoped>
* {
  font-family: 'Roboto', sans-serif;
}
</style>
